/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { EventStateEnum } from "./EventStateEnum";
import {
  EventStateEnumFromJSON,
  EventStateEnumFromJSONTyped,
  EventStateEnumToJSON,
  EventStateEnumToJSONTyped,
} from "./EventStateEnum";
import type { Linestring } from "./Linestring";
import {
  LinestringFromJSON,
  LinestringFromJSONTyped,
  LinestringToJSON,
  LinestringToJSONTyped,
} from "./Linestring";

/**
 * Assumes simulation to be present on Serializer.
 *
 * Validates that the latest simulation status is either "created" or
 * "initialized".
 *
 * If the latest simulation status is "initialized" is also checks
 * if the simulation has been paused.
 *
 * Use this mixin to validate the creation or update of simulation event
 * resources like rain, wind etc
 * @export
 * @interface ObstacleEdit
 */
export interface ObstacleEdit {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset: number;
  /**
   * Absolute or relative height (in meters)  to use for the linestring
   */
  value: number;
  /**
   *
   */
  linestring: Linestring;
  /**
   *
   */
  readonly state?: EventStateEnum;
  /**
   *
   */
  readonly stateDetail?: any | null;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the ObstacleEdit interface.
 */
export function instanceOfObstacleEdit(value: object): value is ObstacleEdit {
  if (!("offset" in value) || value["offset"] === undefined) return false;
  if (!("value" in value) || value["value"] === undefined) return false;
  if (!("linestring" in value) || value["linestring"] === undefined) return false;
  return true;
}

export function ObstacleEditFromJSON(json: any): ObstacleEdit {
  return ObstacleEditFromJSONTyped(json, false);
}

export function ObstacleEditFromJSONTyped(json: any, ignoreDiscriminator: boolean): ObstacleEdit {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset: json["offset"],
    value: json["value"],
    linestring: LinestringFromJSON(json["linestring"]),
    state: json["state"] == null ? undefined : EventStateEnumFromJSON(json["state"]),
    stateDetail:
      json["state_detail"] === undefined
        ? undefined
        : json["state_detail"] === null
        ? null
        : json["state_detail"],
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function ObstacleEditToJSON(json: any): ObstacleEdit {
  return ObstacleEditToJSONTyped(json, false);
}

export function ObstacleEditToJSONTyped(
  value?: Omit<ObstacleEdit, "url" | "simulation" | "state" | "stateDetail" | "uid" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value["offset"],
    value: value["value"],
    linestring: LinestringToJSON(value["linestring"]),
  };
}
